import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { careModeLookup, type CareModeId } from '../content';

type CareModeContextValue = {
  modeId: CareModeId;
  mode: (typeof careModeLookup)[CareModeId];
  setModeId: (id: CareModeId) => void;
};

const CareModeContext = createContext<CareModeContextValue | null>(null);

export function CareModeProvider({ children }: Props) {
  const [modeId, setModeId] = useState<CareModeId>('companion');

  const value = useMemo(
    () => ({
      modeId,
      mode: careModeLookup[modeId],
      setModeId,
    }),
    [modeId],
  );

  return <CareModeContext.Provider value={value}>{children}</CareModeContext.Provider>;
}

export function useCareMode(): CareModeContextValue {
  const context = useContext(CareModeContext);

  if (!context) {
    return {
      modeId: 'companion',
      mode: careModeLookup.companion,
      setModeId: () => undefined,
    };
  }

  return context;
}

interface Props {
  children: ReactNode;
}
